import { render, staticRenderFns } from "./RDropdown.vue?vue&type=template&id=ed74c854&scoped=true&"
import script from "./RDropdown.vue?vue&type=script&lang=js&"
export * from "./RDropdown.vue?vue&type=script&lang=js&"
import style0 from "./RDropdown.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RDropdown.vue?vue&type=style&index=1&id=ed74c854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed74c854",
  null
  
)

/* custom blocks */
import block0 from "./RDropdown.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports